import { ComponentPropsWithRef, forwardRef, memo } from 'react';
import { Span, SpanProps } from '@chakra-ui/react';

const DarkModeComponent = (
  props: SpanProps,
  ref: ComponentPropsWithRef<'span'>['ref'],
) => (
  <Span
    ref={ref}
    className="chakra-theme dark"
    color="fg"
    colorPalette="gray"
    colorScheme="dark"
    display="contents"
    {...props}
  />
);

export const DarkMode = memo(
  forwardRef<HTMLSpanElement, SpanProps>(DarkModeComponent),
);
